var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('epsHeader',{attrs:{"drawer":_vm.$store.state.drawer}}),_c('br'),_c('br'),_c('v-divider'),_c('TabMenu')],1)}
var staticRenderFns = []

export { render, staticRenderFns }